export const GetPartnerList = [
    { text: "General", value: "General" },
    { text: "Google", value: "Google" },
    { text: "YouTube", value: "YouTube" },
];
